import React, { useEffect } from "react";
import "./staking.scss";
import Datatable from "./DataTable/Datatable";
import { Accordion, Modal } from "react-bootstrap";
import { useState } from "react";
import Header from "../landing/navbar/Header";
import GetGemsBalance from "../../hooks/dataFetchers/getTokensBalance";
import GetGemsStaked from "../../hooks/dataFetchers/getGemsStakedAmount";
import StakeGems from "../../hooks/dataSenders/stakeGems";
import UnStakeGems from "../../hooks/dataSenders/unstakeGems";
import StakeGemsGas from "../../hooks/dataSenders/stakeGemsGas";
import AllowanceGems from "../../hooks/dataFetchers/allowanceGems";
import GetGemsStakedIndex from "../../hooks/dataFetchers/getGemsStakedIndex";

import ApproveGems from "../../hooks/dataSenders/approveGems";
import { useWeb3React } from "@web3-react/core";
import Loader from "../../hooks/loader";
import { toast } from "react-toastify";
import axios from "axios";
import Environment from "../../utils/Environment";
import { Api_Url } from "../../utils/ApiUrl";
import moment from "moment";
import { TOKENS } from "../../utils/Constants";
import useWeb3 from "../../hooks/useWeb3";
import { requestWithState } from "../../@api/requestWithState";

const Staking = ({ usdPrice,
  tomiPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
  gemsPrice, }) => {
  // const user_Storage_data = JSON.parse(localStorage?.getItem("user"));
  // const user = { isPremium: true };
  const [token, setToken] = useState(TOKENS[0]);
  const { account } = useWeb3React();
  const { GetGemsBal } = GetGemsBalance();
  const { getGemsStaked } = GetGemsStaked();
  const { stakeGems } = StakeGems();
  const { unstakeGems } = UnStakeGems();
  const { stakeGemsGas } = StakeGemsGas();
  const { allowanceGems } = AllowanceGems();
  const { approveGems } = ApproveGems();
  const { getGemsStakedIndex } = GetGemsStakedIndex();
  const web3 = useWeb3();
  const [loader, setLoader] = useState(false);
  const [user, setTokenNftStats] = useState(JSON.parse(localStorage?.getItem("user")));
  console.log(user, 'userrrrr')
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setWalletError("");
  };
  const handleShow = () => {
    if (!verified) {
      handleShowVerify()
    }
    else {
      setShow(true)
    }
  };

  const [show1, setShow1] = useState(false);

  const handleClose1 = () => {
    setShow1(false);
    setAmount("");
  };
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [openWalletModal, setOpenWalletModal] = useState(false);

  const [amount, setAmount] = useState("400");
  const [amountError, setAmountError] = useState("");
  const [walletError, setWalletError] = useState("");

  const [balance, setBalance] = useState(0);
  const [allowance, setAllowance] = useState(0);

  const [minStakeAmount, setMinStakeAmount] = useState(999999999999999);
  const [stakingGasFees, setStakingGasFees] = useState(0);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [subscriptionEndTime, setSubscriptionEndTime] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);

  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  const [country, setCountry] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage] = useState(10); // Define how many items to show per page
  const [orderBy, setOrderBy] = useState("blockTimestamp");
  const [orderDirection, setOrderDirection] = useState("asc");
  console.log(stakeEndTime, subscriptionEndTime, 'subscriptionEndTime');



  const [otp, setOtp] = useState("");
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [email, setEmail] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [verified, setVerified] = useState(false)

  const [showverify, setShowVerify] = useState(false);
  const handleCloseVerify = (flag) => {

    if (flag) {
       setShow(true)
    }
    setEmail("")
    setOtp("")
    setIsOtpValid(true)
    setShowVerify(false);
  };
  const handleShowVerify = () => setShowVerify(true);



  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      countdown = setTimeout(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [timer, isResendDisabled]);
  console.log(account, 'account')
  const handleSendCode = async (e) => {
    e.preventDefault();
    if (!isEmailValid || isResendDisabled) return;

    try {
      const response = await requestWithState({
        url: `/emails/verify-email`,
        method: "POST",
        data: {
          email,
          by: user?.walletAddress?.toLowerCase(),
          country,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        toast.info('Verification Code Sent Successfully')
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        setShowOtpInput(true);
        toast.info('Verification Code Sent Successfully')
        // Start cooldown
        setIsResendDisabled(true);
        setTimer(10);
      }
    } catch (error) {
      toast.error(error.message)
      console.error("Failed to send verification email:", error);
    }
  };


  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/verify-otp`,
        method: "POST",
        data: {
          email,
          by: user?.walletAddress.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
   
        setVerified(true)
        toast.success("Email verified successfully");
        checkVerification()
        setIsOtpValid(true);
        handleCloseVerify(true);
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };

  const checkVerification = async () => {
    try {
      const response = await requestWithState({
        url: `/emails/wallet-details`,
        method: "POST",
        data: {
          country: country,
          by: user?.walletAddress.toLowerCase()
        },
      });

      console.log(response, "Verification Response")
      if (response?.deta?.isVerified) {
        setVerified(true);
        console.log("Verified fetched successfully:", response?.data);
        // setEmail(response?.deta?.email)
      } else {
        setVerified(false);
        console.log("User is not verified");
      }
    } catch (error) {
      setVerified(false);
      console.error("Error checking premium:", error);
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setIsEmailValid(isValidEmail(value));
  };

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  useEffect(() => {
    if (user?.walletAddress && country) {
      checkVerification()
    }
  }, [user?.walletAddress, country])

  useEffect(() => {
    if (user) {
      get_ApiKeys();

      // getGemsBalanceFunc();
      fetchSubscriptionData();
      fetchStakingData();
      getGemsStakedAmount();
    }
  }, [user]);

  // useEffect(() => {
  //   if (
  //     account && token &&
  //     account.toLowerCase() == user?.walletAddress?.toLowerCase()
  //   ) {
  //     getAllowance(token);
  //   }
  // }, [account, token]);

  const getGemsBalanceFunc = async (token) => {
    const { tokenAddress, decimals, NAME } = token;

    try {
      let bal;

      if (NAME === "ETH") {
        const balanceInWei = await web3.eth.getBalance(user?.walletAddress);
        bal = web3.utils.fromWei(balanceInWei, 'ether');
        bal = parseFloat(bal).toFixed(4);
      } else {
        bal = await GetGemsBal(user?.walletAddress, tokenAddress, decimals);
      }

      if (bal !== null && bal !== undefined) {
        setBalance(bal);
        return bal;
      } else {
        setBalance(0);
        return 0;
      }

    } catch (error) {
      console.error("Error getting token balance:", error);
      setBalance(0);
      return 0;
    }
  };

  const getAllowance = async (token) => {
    if (token?.NAME === 'ETH') {
      setAllowance(0);
      return 0
    }
    const all = await allowanceGems(account, token?.tokenAddress, token?.decimals);
    if (all !== null || all !== undefined) {
      setAllowance(all);
      return all;
    } else {
      return 0
    }
  };

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(user?.walletAddress);

    if (staked !== null || staked !== undefined) {
      setStakedAmount(staked);
    }
  };

  const get_ApiKeys = async () => {
    // let ipp=localStorage.getItem('ip')
    try {
      const response = await axios({
        method: "get",
        url: "https://api.ipify.org",
      });
      //  console.log(ipp,'response', response?.data.ip.ip);
      // if (!ipp||ipp!=response?.data.ip.ip){
      // localStorage.setItem('ip', response?.data.ip.ip)
      get_ApiKeys1(response?.data);
      // }
    } catch (error) {
      // setShowService(false)
      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };

  const get_ApiKeys1 = async (e) => {
    try {
      const response = await axios({
        method: "get",
        url: `https://api.iplocation.net/?ip=${e}`,
      });
      //  console.log(response?.data.country_name,'sdsdsdsds',);
      // localStorage.setItem('ip', response?.data.ip.ip)
      setCountry(response?.data.country_name?.toLowerCase());
      // setCountryyName(response?.data.ip.country)
    } catch (error) {
      // setShowService(false)
      setCountry("india");

      console.log(error, "error");
      // localStorage.setItem('ip',response?.data.ip)
      // localStorage.setItem('country',response?.data.country)
      // throw error;
    }
  };
  async function getPrice(token) {
    try {
      let tokenName
      if (token === 'WBTC') {
        tokenName = 'BTC'
      } else {
        tokenName = token
      }
      const response = await fetch(`${Api_Url}/users/prices?token=${tokenName}`);
      const data = await response.json();

      // Assuming the API returns something like { price: 25.43 }
      return parseFloat(data.data.data)?.toFixed(7);
    } catch (error) {
      console.error("Error fetching price:", error);
      return null;
    }
  }
  const Stake = async () => {
    if (!account) {
      toast.info('Please Connect Your Wallet');
      return;
    }
    console.log("stake func");
    // setLoader(true);
    let tokenBalance = await getGemsBalanceFunc(token);
    console.log(tokenBalance, 'tokenBalance');
    
    const token_Price = await getPrice(token?.NAME);
    console.log(token_Price, 'token_Price');
    let token_allowance = await getAllowance(token);
    console.log(tokenBalance, token_Price, token_allowance, 'tokenBalance');

    if (account) {
      console.log("stake func account yes");

      if (account.toLowerCase() == user?.walletAddress?.toLowerCase()) {
        console.log(
          "stake func account same: ",
          Environment.gems,
          account,
          country
        );

        let config = {
          method: "post",
          url: `${Api_Url}/users/buy-premium-subscription`,
          data: {
            tokenSelected: token.NAME,
            walletAddress: account,
            country: country,

            // walletAddress: account.toLocaleLowerCase(),
            // country: countryBuyer,
            // type: "NODE",
            // tokenSelected: selectedToken?.mainTag,
          },
        };
        console.log("stake func api config");
        let postApiRes = await axios(config)
          .then(function (response) {
            return response?.data?.data;
          })
          .catch(function (error) {
            setLoader(false);
            console.error("API Error:", error);
            toast.error(error?.response?.data?.message || "API request failed");
            return null;
          });
        if (postApiRes) {
          console.log(tokenBalance, amount, token_Price, amount / token_Price, 'amount / token_Priceamount / token_Price');
          if (tokenBalance >= amount / token_Price) {
            if (token?.NAME === 'ETH' || token_allowance >= amount / token_Price) {
              try {
                setLoader(true);
                let subAmount = amount / token_Price;
                console.log(subAmount, 'amount / token_Priceamount / token_Price');
                // Add 2 percent to subAmount
                const increasePercentage = 0.02;

                subAmount = subAmount * (1 + increasePercentage);
                let increasedAmount = subAmount * 10 ** token?.decimals;
                console.log(increasedAmount, 'amount / token_Priceamount / token_Price');


                const gas = await stakeGems(postApiRes, account, token, increasedAmount);
                console.log("gas: ", gas);

                if (gas) {
                  // stakeAPI(gas?.transactionHash, gas?.timestamp);
                  handleClose();
                  handleShow1();
                  setLoader(false);
                  getGemsStakedAmount();
                  getGemsBalanceFunc(token);
                  setTimeout(() => {
                    fetchSubscriptionData();
                  }, 5000);

                  // setStakingGasFees(gas);
                  // handleShow();
                }
              } catch (e) {
                setLoader(false);
                console.error(e);
                toast.error(e?.message);
              }
            } else {
              try {
                setLoader(true);
                console.log(amount / token_Price, amount, token_Price, 'amount / token_Price');
                // amount / token_Price       
                const approve = await approveGems(account, tokenBalance, token?.tokenAddress, token?.decimals);
                if (approve) {
                  getAllowance(token);
                  let tokenBalance = await getGemsBalanceFunc(token);
                  if (tokenBalance >= amount) {
                    try {
                      let subAmount = amount / token_Price;
                      const gas = await stakeGems(postApiRes, account, token, subAmount);
                      console.log("gas: ", gas);
                      if (gas) {
                        // stakeAPI(gas?.transactionHash, gas?.timestamp);
                        handleClose();
                        handleShow1();
                        setLoader(false);
                        getGemsStakedAmount();
                        getGemsBalanceFunc(token);

                        setTimeout(() => {
                          fetchStakingData();
                          fetchSubscriptionData();
                        }, 5000);

                        // setStakingGasFees(gas);
                        // handleShow();
                      }
                    } catch (e) {
                      setLoader(false);
                      console.error(e);
                      toast.error(e?.message);
                    }
                  } else {
                    // handleShow2();
                    setLoader(false);

                    setWalletError(`Not Enough ${token?.NAME} Balance`);
                  }
                }
              } catch (e) {
                setLoader(false);
                console.error(e);
                toast.error(e?.message);
              }
            }
          } else {
            setLoader(false);
            // handleShow2();
            setWalletError(`Not Enough ${token?.NAME} Balance`);
          }
        }
      } else {
        setWalletError("Incorrect Wallet!");
        setLoader(false);
      }
    } else {
      // setWalletError("Connect Wallet!");
      handleClose();
      setOpenWalletModal(true);
      setLoader(false);
    }
  };

  const unstake = async () => {
    if (
      account &&
      account?.toLowerCase() == user?.walletAddress?.toLowerCase()
    ) {
      setLoader(true);
      try {
        const index = await getGemsStakedIndex(account);
        if (index) {
          try {
            const gas = await unstakeGems(account, parseInt(index) - 1);
            if (gas) {
              // handleShow1();

              setLoader(false);
              getGemsStakedAmount();
              setTimeout(() => {
                fetchStakingData();
                fetchSubscriptionData();
              }, 5000);

              handleShow3();
              // getGemsBalanceFunc();
              // setStakingGasFees(gas);
              // handleShow();
            }
          } catch (e) {
            setLoader(false);
            console.error(e);
            toast.error(e?.message);
          }
        }
      } catch (e) {
        setLoader(false);

        console.error(e);
      }
    } else {
      setAmountError("Incorrect Wallet!");
      toast.error("Please Connect the Leader's Wallet!");
    }
  };

  const calculateStakeGas = async () => {
    if (account.toLowerCase() == user?.walletAddress?.toLowerCase()) {
      setLoader(true);
      if (allowance > amount) {
        try {
          const gas = await stakeGemsGas(account, amount);
          if (gas) {
            setStakingGasFees(gas);
            handleShow();
            setLoader(false);
          }
        } catch (e) {
          setLoader(false);
          console.error(e);
          toast.error(e?.message);
        }
      } else {
        try {
          const approve = await approveGems(account);
          if (approve) {
            getAllowance();

            const gas = await stakeGemsGas(account, amount);

            if (gas) {
              setStakingGasFees(gas);
              handleShow();
              setLoader(false);
            }
          }
        } catch (e) {
          setLoader(false);
          console.error(e);
          toast.error(e?.message);
        }
      }
    } else {
      setAmountError("Incorrect Wallet!");
    }
  };

  // const stakeAPI = async (txHash, txTime) => {
  //   // txTime 1744876284
  //   let tok = localStorage.getItem("accessToken");
  //   var config = {
  //     method: "patch",
  //     // url: `${Api_Url}/users/update-leader-plan`,
  //     url: `${Api_Url}/users/${user_Storage_data?._id}/leader-premium`,
  //     data: {
  //       txHash: txHash,
  //       txTime: txTime?.toString(),
  //     },
  //     headers: {
  //       authorization: `Bearer ` + tok,
  //     },
  //   };
  //   await axios(config)
  //     .then(function (response) { })
  //     .catch(function (error) {
  //       console.error(error?.message);
  //     });
  // };

  //   const fetchSubscriptionData = async () => {
  //     setLoader(true);
  //     var data = JSON.stringify({
  //       query: `query MyQuery {
  //   subscribeds(where: {by: "${user?.walletAddress}"}, orderBy: blockTimestamp, orderDirection: desc) {
  //     blockTimestamp
  //     blockNumber
  //     amountPurchased
  //     by
  //     endTime
  //     id
  //     tokenPrice
  //     transactionHash
  //   }
  // }`,
  //       variables: {},
  //     });
  //     var config = {
  //       method: "post",
  //       url: Environment.GEMSSubscriptionGraph_v2,
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       data: data,
  //     };
  //     await axios(config)
  //       .then(async function (response) {
  //         const resData = response.data.data.subscribeds;
  //         if (resData.length > 0) {
  //           // setStakeIndux1(parseInt(resData[0]?.stakerStakeIndex));
  //           setSubscriptionData(resData);
  //           console.log("res data: ", resData);

  //           const currentTime = moment();
  //           const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
  //           // const endTimeStamp = endTimeStampInSeconds * 1000; // Convert to milliseconds
  //           const endTimeStamp = moment(endTimeStampInSeconds * 1000);

  //           const utcISO = new Date(endTimeStamp).toISOString();
  //           console.log("subscription end time: ", currentTime, endTimeStamp);

  //           if (!endTimeStamp) {
  //             setSubscriptionEndTime(currentTime);
  //           } else {
  //             setSubscriptionEndTime(endTimeStamp);
  //           }
  //         }
  //         setLoader(false);
  //       })
  //       .catch(function (error) {
  //         setLoader(false);
  //         console.log(error, "error");
  //       });
  //   };
  const fetchSubscriptionData = async (useV2 = false) => {
    setLoader(true);

    const graphURL = useV2
      ? Environment.GEMSSubscriptionGraph_v2
      : Environment.GEMSSubscriptionGraph;

    const data = JSON.stringify({
      query: `query MyQuery {
      subscribeds(where: {by: "${user?.walletAddress}"}, orderBy: blockTimestamp, orderDirection: desc) {
        blockTimestamp
        blockNumber
        amountPurchased
        by
        endTime
        id
        tokenPrice
        transactionHash
      }
    }`,
      variables: {},
    });

    const config = {
      method: "post",
      url: graphURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios(config);
      const resData = response.data.data.subscribeds;
      // If no data and not already using v2, retry with v2
      if ((!resData || resData.length === 0) && !useV2) {
        return fetchSubscriptionData(true);
      }
      if (resData.length > 0) {
        setSubscriptionData(resData);

        const currentTime = moment();
        const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
        const endTimeStamp = moment(endTimeStampInSeconds * 1000);

        console.log("subscription end time: ", currentTime, endTimeStamp);

        if (!endTimeStamp || currentTime.isAfter(endTimeStamp)) {
          if (!useV2) {
            // Re-fetch with v2 if not already using it
            return fetchSubscriptionData(true);
          } else {
            setSubscriptionEndTime(currentTime); // fallback if still no valid endTime
          }
        } else {
          setSubscriptionEndTime(endTimeStamp);
        }
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log(error, "error");
    }
  };

  const fetchStakingData = async () => {
    try {
      const response = await axios.post(
        Environment?.GEMSStakingGraph,
        {
          query: `
            query MyQuery($staker: String, $isClaimed: Boolean,) {
              stakeds(where: {staker: $staker}, isClaimed: $isClaimed,) {
              
                blockTimestamp
                stakeEndTime
                isClaimed
              }
            }`,
          variables: {
            staker: user?.walletAddress,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const resData = response.data.data.stakeds;
      setStakingData(resData);
      console.log("staaking data: ", resData);

      const currentTime = moment();
      const endTimeStampInSeconds = parseInt(
        resData[resData?.length - 1]?.stakeEndTime
      );
      const endTimeStamp = moment(endTimeStampInSeconds * 1000);
      console.log("stake time: ", currentTime, endTimeStamp);

      if (!endTimeStamp.isValid()) {
        setStakeEndTime(currentTime);
      } else {
        setStakeEndTime(endTimeStamp);
      }
    } catch (error) {
      console.error("Error fetching staking data: ", error);
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || (Number(value) <= balance && Number(value) >= 0)) {
      setAmount(value);
      setAmountError("");
    } else {
      setAmountError("Amount exceeds balance");
    }
  };

  const handleSorting = (sortBy) => {
    setOrderBy(sortBy);
    setOrderDirection(
      orderBy === sortBy && orderDirection === "asc" ? "desc" : "asc"
    );
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const GetMyData = async () => {
    const apiUrl = `${Api_Url}/users/dashboard/my/stats`;
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: apiUrl,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        let value = response?.data?.data;
        setTokenNftStats(value);

      })
      .catch(function (error) {
        // console.log("status: ", error?.response);
        if (error?.response?.status == 401) {
          // history.push("/login");
        }

        console.log(error);
      });
    // }
  };
  useEffect(() => {
    GetMyData()
  }, [])
  return (
    <>
      {loader && <Loader />}
      <Header
        openWalletModal={openWalletModal}
        setOpenWalletModal={setOpenWalletModal}
      />
      <section className="main-staking">
        <div className="upperbanner">
           <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\loginvideo.mp4" type="video/mp4" />
          </video>
          <div className="theme-container">
            <h6 className="staketoppara">Golden Discount</h6>
            <h4 className="stakemainhead">
              Enjoy 100% of your rewards with Xen Premium!
            </h4>
            <p>Lock XEN token for a year and enjoy full potential of GEMS platform</p>
          </div>
        </div>
        <div className="lowerbanner">
          <div className="theme-container">
            {/* <div className="lowerinnerbanner">
              <div className="lowerleft">
                <span className="lowerleftshade"></span>
                <h6 className="totalpara">TOTAL GEMS Staked</h6>
                <div className="totalgemsmain">
                  <img
                    src="\assets\gemstoken.svg"
                    alt="gemslogoimg"
                    className="gemslogoimg"
                  />
                  <p className="totalgemspara">
                    {stakedAmount?.toLocaleString()} GEMS
                  </p>
                </div>
                <div className="stakebalance">
                  <p className="stakepara">Stake GEMS</p>
                  <p className="balancepara">
                    <span>Balance:</span>
                    <span>{balance?.toLocaleString()} GEMS</span>
                  </p>
                </div>
                <input
                  type="number"
                  placeholder="Enter amount of GEMS to stake"
                  className="amountinput"
                  value={amount}
                  max={balance}
                  onChange={handleAmountChange}
                />
                <div className="mb-4">
                  <p className="text-danger">{amountError}</p>
                </div>
                <div className="stakingperiodmain">
                  <p className="stakingperiodpara">Staking Period</p>
                  <p className="stakingyearpara">1 Year </p>
                </div>
                <button
                  // onClick={handleShow}
                  className="approvebtn"
                  // disabled={amount < 18000}
                  onClick={() => {
                    if (!account) {
                      // setAmountError("Connect Wallet First!");
                      toast.info("Connect Your Wallet");
                    } else if (amount < 18000) {
                      setAmountError("Cannot stake less than 18000 GEMS!");
                    } else if (balance > amount) {
                      // Stake();
                      calculateStakeGas();
                    } else {
                      setAmountError("Insufficient GEMS Balance!");
                    }
                  }}
                >
                  {allowance > amount ? "Stake" : "Approve"}
                </button>
              </div>
              <div className="lowerright">
                <p className="lowerrightpara">Stake History</p>
                <Datatable
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  totalItems={totalItems}
                  orderBy={orderBy}
                  setOrderBy={setOrderBy}
                  orderDirection={orderDirection}
                  setOrderDirection={setOrderDirection}
                  setCurrentPage={setCurrentPage}
                  stakingData={stakingData}
                  handlePagination={handlePagination}
                  handleSorting={handleSorting}
                  unstake={unstake}
                />
              </div>
            </div> */}
            <div className="newboxes-twice">
              <div className="single-box">
                <div className="upper-content">
                  <h6>basic</h6>
                  <h4>
                    <span>$0</span>
                  </h4>
                  {/* <p>Your starting point in your GEMS leader journey!</p> */}
                </div>
                <div className="bottom-content">
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "#05BADA", fontFamily: "hsemibold" }}>Launchpad</p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Private sale first round discount</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Private sale additional rounds discount</p>
                    </div>
                    <div className="text">
                      <span className="redtext">0%</span>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        Miner Safeguard <span className="orange-text">New</span>
                      </p>
                    </div>
                    <div className="text">
                   <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.8029 4L14.9161 4L11.0003 10.9951L13.8871 10.9951L17.8029 4Z" fill="#FF3235"/>
  <path d="M17.8029 18.0059L14.9161 18.0059L11.0003 11.0108L12.8197 9.80147L13.8871 11.0108L17.8029 18.0059Z" fill="#FF3235"/>
  <path d="M4.20276 4L7.08954 4L11.0053 10.9951L8.11854 10.9951L4.20276 4Z" fill="#FF3235"/>
  <path d="M4.20288 18.0059L7.08966 18.0059L11.0054 11.0108L9.18607 9.80147L8.11866 11.0108L4.20288 18.0059Z" fill="#FF3235"/>
</svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>
                        Credit Refund <span className="orange-text">New</span>
                      </p>
                    </div>
                    <div className="text">
                   <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.8029 4L14.9161 4L11.0003 10.9951L13.8871 10.9951L17.8029 4Z" fill="#FF3235"/>
  <path d="M17.8029 18.0059L14.9161 18.0059L11.0003 11.0108L12.8197 9.80147L13.8871 11.0108L17.8029 18.0059Z" fill="#FF3235"/>
  <path d="M4.20276 4L7.08954 4L11.0053 10.9951L8.11854 10.9951L4.20276 4Z" fill="#FF3235"/>
  <path d="M4.20288 18.0059L7.08966 18.0059L11.0054 11.0108L9.18607 9.80147L8.11866 11.0108L4.20288 18.0059Z" fill="#FF3235"/>
</svg>
                    </div>
                  </div>
                  <div className="inner-single singlearea">
                    <div
                      className="text"
                      style={{ justifyContent: "flex-start" }}
                    >
                      <p style={{ color: "#05BADA", fontFamily: "hsemibold" }}>Trade</p>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Lower trade fees</p>
                    </div>
                    <div className="text">
                   <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.8029 4L14.9161 4L11.0003 10.9951L13.8871 10.9951L17.8029 4Z" fill="#FF3235"/>
  <path d="M17.8029 18.0059L14.9161 18.0059L11.0003 11.0108L12.8197 9.80147L13.8871 11.0108L17.8029 18.0059Z" fill="#FF3235"/>
  <path d="M4.20276 4L7.08954 4L11.0053 10.9951L8.11854 10.9951L4.20276 4Z" fill="#FF3235"/>
  <path d="M4.20288 18.0059L7.08966 18.0059L11.0054 11.0108L9.18607 9.80147L8.11866 11.0108L4.20288 18.0059Z" fill="#FF3235"/>
</svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p> Sign-in reward</p>
                    </div>
                    <div className="text">
                 <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.8029 4L14.9161 4L11.0003 10.9951L13.8871 10.9951L17.8029 4Z" fill="#FF3235"/>
  <path d="M17.8029 18.0059L14.9161 18.0059L11.0003 11.0108L12.8197 9.80147L13.8871 11.0108L17.8029 18.0059Z" fill="#FF3235"/>
  <path d="M4.20276 4L7.08954 4L11.0053 10.9951L8.11854 10.9951L4.20276 4Z" fill="#FF3235"/>
  <path d="M4.20288 18.0059L7.08966 18.0059L11.0054 11.0108L9.18607 9.80147L8.11866 11.0108L4.20288 18.0059Z" fill="#FF3235"/>
</svg>
                    </div>
                  </div>
                  <div className="inner-single">
                    <div className="text">
                      <p>Affiliate Program</p>
                    </div>
                    <div className="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M17.8029 4L14.9161 4L11.0003 10.9951L13.8871 10.9951L17.8029 4Z" fill="#FF3235"/>
  <path d="M17.8029 18.0059L14.9161 18.0059L11.0003 11.0108L12.8197 9.80147L13.8871 11.0108L17.8029 18.0059Z" fill="#FF3235"/>
  <path d="M4.20276 4L7.08954 4L11.0053 10.9951L8.11854 10.9951L4.20276 4Z" fill="#FF3235"/>
  <path d="M4.20288 18.0059L7.08966 18.0059L11.0054 11.0108L9.18607 9.80147L8.11866 11.0108L4.20288 18.0059Z" fill="#FF3235"/>
</svg>
                    </div>
                  </div>
                </div>
                {console.log(stakingData, subscriptionData, 'useruseruseruser')
                }
                {user?.isPremium == true ||
                  (stakingData?.length > 0 && stakingData?.isClaimed == false) ||
                  subscriptionData?.length > 0 ? null : (
                  <a className="btn-plan" style={{ marginTop: "30px" }}>CURRENT PLAN</a>
                )}
              </div>
              <div className="main-bottom-ahead">
                <div className="single-box activee">
                  <span className="gradient-activee"></span>
                  <div className="upper-content">
                    <div className="d-flex justify-content-between align-item-center">
                      <h6 style={{ color: "#EAB44C" }}>
                       
                      Golden Discount
                      </h6>
                      {subscriptionData?.length > 0 &&
                        moment().isAfter(subscriptionEndTime) &&
                        stakingData?.length > 0 &&
                        subscriptionEndTime.isAfter(stakeEndTime) ? (
                        <p
                          className="cdhbdybydbcy"
                          style={{ color: "#FF4A4A" }}
                        >
                          Plan expired on{" "}
                          {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : subscriptionData?.length > 0 &&
                        moment() > subscriptionEndTime &&
                        stakingData?.length > 0 &&
                        moment().isAfter(stakeEndTime) &&
                        stakingData[stakingData.length - 1]?.isClaimed ==
                        false ? (
                        <p
                          className="cdhbdybydbcy"
                          style={{ color: "#FF4A4A" }}
                        >
                          Plan expired on{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : null}
                    </div>
                    <h4>
                      <span>$400</span>{" "}
                      <div className="setpara">
                        <p>/year </p>
                        <p>Paid in ${token?.NAME}</p>
                      </div>
                    </h4>
                    {/* <p>Enjoy full benefits of the GEMS platform!</p> */}
                  </div>
                  <div className="bottom-content">
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "#05BADA", fontFamily: "hsemibold" }}>
                          Launchpad
                        </p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Private sale first round discount</p>
                      </div>
                      <div className="text">
                        <span className="greentext">20%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Private sale additional rounds discount</p>
                      </div>
                      <div className="text">
                        <span className="greentext">7%</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          Miner Safeguard{" "}
                          <span className="orange-text">New</span>
                        </p>
                      </div>
                      <div className="text">
                       <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
  <path d="M12.5198 5.1482L12.5198 0L4.67608 7.82416L0 4.52524L4.16878e-07 9.29801L4.67608 12.8215L12.5198 5.1482Z" fill="#05BADA"/>
</svg>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>
                          Credit Refund <span className="orange-text">New</span>
                        </p>
                      </div>
                      <div className="text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
  <path d="M12.5198 5.1482L12.5198 0L4.67608 7.82416L0 4.52524L4.16878e-07 9.29801L4.67608 12.8215L12.5198 5.1482Z" fill="#05BADA"/>
</svg>
                      </div>
                    </div>
                    <div className="inner-single singlearea">
                      <div
                        className="text"
                        style={{ justifyContent: "flex-start" }}
                      >
                        <p style={{ color: "#05BADA", fontFamily: "hsemibold" }}>Trade</p>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Lower trade fees</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p> Sign-in reward</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                    <div className="inner-single">
                      <div className="text">
                        <p>Affiliate Program</p>
                      </div>
                      <div className="text">
                        <span>TBA</span>
                      </div>
                    </div>
                  </div>
                  <div class="dropdown dropdownstakingtoken">
                    <button class="dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                      <div className="leftdrop">
                        Pay With <img src={`/assets/staking/${token?.tokenImg}.svg`} alt="img" className="img-fluid" /> <span>{token?.NAME}</span>
                      </div>
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M5 7.5L10 12.5L15 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      {TOKENS?.map((token) => (
                        <li key={token.tokenImg}>
                          <a
                            className="dropdown-item"
                            href="#"
                            onClick={() => setToken(token)}
                          >
                            <img
                              src={`/assets/staking/${token?.tokenImg}.svg`}
                              alt={token?.NAME}
                              className="img-fluid"
                            />
                            {token?.NAME}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {subscriptionData?.length == 0 &&
                    user?.isPremium == false &&
                    stakedAmount < 18000 ? (
                    <button
                      className="btn-plan activee"
                      disabled={
                        stakingData.length > 0 &&
                        stakingData[stakingData.length - 1]?.isClaimed == false
                      }
                      onClick={() => {
                        !account ? toast.error('Please connect your wallet') :
                        handleShow();
                      }}
                    >
                      Get Xen Premium
                    </button>
                  ) : (subscriptionData?.length > 0 &&
                    subscriptionEndTime > moment()) ||
                    user?.isPremium == true ||
                    (stakingData?.length > 0 &&
                      moment().isBefore(stakeEndTime)) ? (


                    <a
                      className="btn-plan"
                      style={{ justifyContent: "space-between" }}
                    >
                      {/* {console.log(subscriptionData, subscriptionEndTime, subscriptionEndTime > moment(), stakingData, moment().isBefore(stakeEndTime), stakeEndTime, 'asdfasdsfassfadssfss')} */}
                      <h6>CURRENT PLAN</h6>
                      {stakeEndTime < moment() ? (
                        <p>
                          expires on{" "}
                          {moment(subscriptionEndTime)?.format("DD/MM/YY")}
                        </p>
                      ) : (
                        <p>
                          expires on {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      )}
                    </a>
                  ) : stakingData?.length > 0 &&
                    moment().isAfter(stakeEndTime) ? (
                    <div className="twice-btns" style={{ gap: "10px" }}>
                      {/* {stakingData[stakingData.length - 1]?.isClaimed == false && (
                        <a
                          className="withdraw-gems"
                          onClick={() => {
                            unstake();
                          }}
                        >
                          Withdraw 18000 Xen
                        </a>
                      )} */}
                      <button
                        className="upgrade-gems"
                        disabled={
                          stakingData.length > 0 &&
                          stakingData[stakingData.length - 1]?.isClaimed ==
                          false
                        }
                        onClick={() => {
                        
                          handleShow();
                        }}
                      >
                        Get Xen Premium
                      </button>
                    </div>
                  ) : subscriptionData?.length == 0 &&
                    subscriptionEndTime < moment() ? (
                    <div className="twice-btns" style={{ gap: "10px" }}>
                      {/* <a
                        className="withdraw-gems"
                        onClick={() => {
                          unstake();
                        }}
                      >
                        Withdraw Xen
                      </a> */}
                      <a
                        className="upgrade-gems"
                        onClick={() => {
                          handleShow();
                        }}
                      >
                        Upgrade Again
                      </a>
                    </div>
                  ) : null}
                  {stakingData?.length > 0 &&
                    stakingData[stakingData.length - 1]?.isClaimed == false &&
                    moment().isAfter(stakeEndTime) && (
                      <>
                        <Accordion
                          defaultActiveKey="0"
                          className="withdrawaccordion"
                        >
                          <Accordion.Item eventKey="0">
                            <Accordion.Header>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="26"
                                viewBox="0 0 26 26"
                                fill="none"
                              >
                                <path
                                  d="M20.5832 3.25H5.4165L2.1665 9.75L12.9998 22.75L23.8332 9.75L20.5832 3.25ZM10.4215 8.66667L12.0465 5.41667H13.9532L15.5782 8.66667H10.4215ZM11.9165 10.8333V18.07L5.89317 10.8333H11.9165ZM14.0832 10.8333H20.1065L14.0832 18.07V10.8333ZM20.8648 8.66667H17.994L16.369 5.41667H19.2398L20.8648 8.66667ZM6.75984 5.41667H9.63067L8.00567 8.66667H5.13484L6.75984 5.41667Z"
                                  fill="#E89735"
                                />
                              </svg>
                              You are already subscribed to Xen Premium
                            </Accordion.Header>
                            <Accordion.Body>
                              <p className="accpara">
                                You will continue to enjoy your Xen Premium
                                benefits as long as your GEMS remain locked.
                              </p>
                              <p className="accpara mb-0">
                                If you choose to withdraw your locked tokens,
                                your Xen Premium benefits will be{" "}
                                <span className="bolder">canceled</span>, and
                                you can{" "}
                                <span className="bolder">
                                  resubscribe at a rate of $400 per year.
                                </span>
                              </p>
                              {/* <button
                          className="dullbtn"
                        >
                          Withdraw 18,000 GEMS
                        </button> */}

                              {stakeEndTime < moment() ? (
                                <button
                                  className="withdrawbtn"
                                  onClick={() => {
                                    unstake();
                                  }}
                                >
                                  Withdraw 18,000 GEMS
                                </button>
                              ) : (
                                <>
                                  <button className="dullbtn">
                                    Withdraw 18,000 GEMS
                                  </button>
                                  <p className="lastparaacc">
                                    Current Plan expires on{" "}
                                    {moment(stakeEndTime)?.format("DD/MM/YY")}
                                  </p>
                                </>
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </>
                    )}

                  {/* <a href="#" className="btn-plan" style={{flexDirection: "column"}}>
                    <h6>CURRENT PLAN</h6>
                    <p>expires on 6/07/24</p>
                  </a> */}
                  {/* <div className="twice-btns">
                    <a className="withdraw-gems" onClick={()=>{unstake();}}>
                      Withdraw Xen
                    </a>
                    <a href="#" className="upgrade-gems">
                      upgrade Again
                    </a>
                  </div> */}
                </div>
                {/* <p className="bottom-para">
                  *In order to enter the first round you need to be a premium
                  leader and hold total amount of at least 30k gems{" "}
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="stakingmodal premiumstake-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upgrade to Premium</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium-icon1.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Are you sure you want to <br />
                upgrade to GEMS PREMUM?
              </h5>
              <p>
                You will be paying $400 in ${token?.NAME} to enjoy 1 year of Xen
                premium.
              </p>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <p className="text-danger ">{walletError}</p>
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClose();
                }}
                className="cancelbtn"
              >
                Cancel
              </button>
              <button
                className="confirmbtn"
                onClick={() => {
                  Stake();
                }}
              >
                Yes Upgrade
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upgrade to Premium</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <img
              src="\assets\tickimg.svg"
              alt="addedimg"
              className="addedimg"
            />
            <h6 className="successhead">Upgraded to premium</h6>
            <p className="succesaspara">
              Enjoy 100% of your rewards and all <br /> the premium features!
            </p>
            <button
              className="greybtn w-100"
              onClick={() => {
                handleClose1();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upgrade to Premium</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <img
              src="\assets\premium\cross.svg"
              alt="addedimg"
              className="addedimg"
              style={{ width: "100px" }}
            />
            <h6 className="successhead">Insufficient GEMS Balance</h6>
            <p className="succesaspara">
              You do not have enough GEMS in <br /> your wallet!
            </p>
            <button
              className="greybtn w-100"
              onClick={() => {
                handleClose2();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="addedmodal">
            <img
              src="\assets\tickimg.svg"
              alt="addedimg"
              className="addedimg"
            />
            <h6 className="successhead">18,000 GEMS Unstaked</h6>
            <p className="succesaspara">Please check your wallet for details</p>
            <button
              className="greybtn w-100"
              onClick={() => {
                handleClose3();
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        className="stakingmodal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static"        // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="verification-modal">
            <p className="para">
              We will email you a 6-digit code to verify your email address. Enter the code below.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <div className="material-textfield">
                  <input
                    type="text"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={handleEmailChange}
                  />
                  <a
                    href="#"
                    className={`btn-send ${!isEmailValid || isResendDisabled ? "disabled" : ""}`}
                    onClick={handleSendCode}
                    style={{
                      pointerEvents: !isEmailValid || isResendDisabled ? "none" : "auto",
                      opacity: !isEmailValid || isResendDisabled ? 0.5 : 1,
                    }}
                  >
                    {isResendDisabled ? `Resend in ${timer}s` : "Send Code"}
                  </a>
                </div>

              </div>
            </div>

            {/* {showOtpInput && ( */}
              <div style={{ opacity: showOtpInput ? 1 : 0.5, pointerEvents: showOtpInput ? "auto" : "none" }}>
                <div className="option-field" style={{ marginTop: "25px" }}>
                  <label style={{ color: "var(--V6-Dark-Theme-Secondary-Text-Color)" }}>
                    Verification Code
                  </label>
                  <div className="inside-input">
                    <div className="material-textfield">
                      <input
                        type="text"
                        placeholder="Enter 6-digit code here"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                {!isOtpValid && (
                  <p className="error-text">Invalid email verification code</p>
                )}

                <div className="twice-btnsss">
                  <button
                  style={{ opacity: otp.length !== 6 ? 0.5 : 1, pointerEvents: otp.length !== 6 ? "none" : "auto", marginTop: "28px" }}
                    className={ `greybtn sscscscscscsc ${otp.length !== 6 ? "disabled" : ""}`}
                    // style={{ marginTop: "28px" }}
                    onClick={handleVerifyOtp}
                    disabled={otp.length !== 6}
                  >
                    Verify Code
                  </button>
                </div>
              </div>
            {/* )} */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Staking;
